import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PaymentSettingsService } from 'src/app/services/PaymentSettings.service';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { ANGULAR_MODULES, GENERAL_COMPONENTS, Operational_COMPONENTS, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import Swal from 'sweetalert2';
import { ViewChild, ElementRef } from '@angular/core';
import { EPaymentGateway } from 'src/app/Shared/enum';
import * as bootstrap from 'bootstrap';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-ops-online-payment-settings',
  imports: [Operational_COMPONENTS, ANGULAR_MODULES, GENERAL_COMPONENTS, SYNCFUSION_MODULES, LoaderComponent],
  standalone: true,
  templateUrl: './ops-online-payment-settings.html',
  styleUrl: './ops-online-payment-settings.scss'
})
export class OpsOnlinePaymentSettings {
  @ViewChild('terminalDeviceModal')
  terminalDeviceModal!: ElementRef;

  isCollapsed = true;
  disSettings: boolean = true;

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }
  loaderIcon: Promise<boolean>;
  private subscriptions: Subscription[] = [];
  PaymentSettingsForm: FormGroup;
  GateWayList = [];
  editRight: boolean;
  viewRight: boolean;
  viewRightFalseMessage;
  editRightFalseMessage;
  DisablePaymentForm = false;
  marketName = "";
  shopperLicenseEnabled = false;
  public DropDownfields: Object = { text: 'GateWayName', value: 'McsIntPaymentGateway' };
  response;
  readonly EPaymentGateway = EPaymentGateway;
  TerminalDeviceForm!: FormGroup;
  TerminalDevices = [];
  isEditMode = false;

  private readonly openEdgeFieldLabels: Record<string, string> = {
    XWEBID: "XWeb ID",
    XWEBTERMINALID: "XWeb Terminal ID",
    XWEBAUTHKEY: "XWeb Auth Key",
    RCMURL: "RCM URL",
    CardNotPresentURL: "Card Not Present URL",
    QueryPaymentStatusURL: "Query Payment Status URL",
    APIIntegrationURL: "API Integration URL"
  };

  private readonly stripeFieldLabels: Record<string, string> = {
    AccountId: "Account ID",
    PublishableKey: "Publishable Key",
    SecretKey: "Secret Key",
    WebhookSecretKey: "Webhook Secret Key",
    TransferWebhookSecretKey: "Transfer Webhook Secret Key",
    TerminalIpUrl: "Terminal IP / URL",
    AccountOwner: "Account Owner"
  };

  constructor(private formBuilder: FormBuilder,
    private toastr: ToastrService, private paymentService: PaymentSettingsService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private router: Router) {

    this.subscriptions.push(this.paymentService.GetPaymentGateWays().subscribe((res: any) => {
      this.loaderIcon = Promise.resolve(true);
      this.GateWayList = res.map(el => ({
        McsIntPaymentGateway: el.GateWayId,
        GateWayName: el.GateWayName
      }));

      this.loaderIcon = Promise.resolve(false);
    }));

    this.PaymentSettingsForm = this.formBuilder.group(
      {
        McsIntPaymentGateway: [0],
        McsBitProcessCreditCardOnline: [false],
        EnableAutopay: [false],
        EnableACH: [false],
        McsBitSecurityCodeMandatory: [false],
        McsBitStreetZipMandatory: [false],
        McsVchGatewayDetails: [""],

        XWEBID: [""],
        XWEBTERMINALID: [""],
        XWEBAUTHKEY: [""],
        RCMURL: [""],
        CardNotPresentURL: [""],
        QueryPaymentStatusURL: [""],
        APIIntegrationURL: [""],
        UserID: [""],
        Password: [""],
        BatchCloseIntegrationURL: [""],
        EcommerceXWebId: [""],
        EcommerceXWebTerminalId: [""],
        EcommerceXWebAuthKey: [""],
        DISABLEDEBITSALE: [false],
        AccountId: [""],
        PublishableKey: [""],
        SecretKey: [""],
        WebhookSecretKey: [""],
        TransferWebhookSecretKey: [""],
        TerminalIpUrl: [""],
        AccountOwner: [""],
        MandatoryAddressField: [false],
      });

    this.TerminalDeviceForm = this.formBuilder.group({
      Id: [0],
      Devices: ['', [Validators.required, this.noWhitespaceValidator.bind(this), Validators.maxLength(200)]],
      TerminalReaderId: ['', [Validators.required, this.noWhitespaceValidator.bind(this), Validators.maxLength(400)]],
      Primary: [false],
      PaymentGatewayId: [0, Validators.required]
    });

    this.subscriptions.push(
      this.PaymentSettingsForm.get('McsBitProcessCreditCardOnline')
        .valueChanges.subscribe(value => {
          this.toggleGatewayFields(value);
          if (value) {
            this.PaymentSettingsForm.get('McsIntPaymentGateway')
              ?.setValidators([Validators.required]);
            this.PaymentSettingsForm.get('McsIntPaymentGateway')
              ?.updateValueAndValidity({ emitEvent: false });
            this.configureGatewayValidators();
          }
          else {
            this.PaymentSettingsForm.get('McsIntPaymentGateway')
              ?.clearValidators();
            this.PaymentSettingsForm.get('McsIntPaymentGateway')
              ?.updateValueAndValidity({ emitEvent: false });
            this.clearGatewayValidators();
          }
        })
    );

    this.subscriptions.push(
      this.PaymentSettingsForm.get('McsIntPaymentGateway')
        ?.valueChanges.subscribe(() => {

          if (this.PaymentSettingsForm.get('McsBitProcessCreditCardOnline')?.value) {
            this.configureGatewayValidators();
          }
        })
    );
  }

  private configureGatewayValidators(): void {
    const openEdgeFields = [
      'XWEBID',
      'XWEBTERMINALID',
      'XWEBAUTHKEY',
      'RCMURL',
      'CardNotPresentURL',
      'QueryPaymentStatusURL',
      'APIIntegrationURL'
    ];

    const stripeFields = [
      'AccountId',
      'PublishableKey',
      'SecretKey',
      'WebhookSecretKey',
      'TransferWebhookSecretKey',
      'TerminalIpUrl',
      'AccountOwner'
    ];

    [...openEdgeFields, ...stripeFields].forEach(field => {
      const control = this.PaymentSettingsForm.get(field);
      control?.clearValidators();
      control?.updateValueAndValidity({
        emitEvent: false
      });
    });

    const gatewayId = this.PaymentSettingsForm.get('McsIntPaymentGateway')?.value;

    const fields =
      gatewayId === this.EPaymentGateway.OpenEdgeExpress
        ? openEdgeFields
        : gatewayId === this.EPaymentGateway.Stripe
          ? stripeFields
          : [];

    fields.forEach(field => {
      this.PaymentSettingsForm.get(field)
        ?.setValidators(Validators.required);
      this.PaymentSettingsForm.get(field)
        ?.updateValueAndValidity({ emitEvent: false });
    });
  }

  private clearGatewayValidators(): void {
    [
      'XWEBID',
      'XWEBTERMINALID',
      'XWEBAUTHKEY',
      'RCMURL',
      'CardNotPresentURL',
      'QueryPaymentStatusURL',
      'APIIntegrationURL',
      'AccountId',
      'PublishableKey',
      'SecretKey',
      'WebhookSecretKey',
      'TransferWebhookSecretKey',
      'TerminalIpUrl',
      'AccountOwner'
    ].forEach(field => {
      this.PaymentSettingsForm.get(field)?.clearValidators();
      this.PaymentSettingsForm.get(field)
        ?.updateValueAndValidity({ emitEvent: false });
    });
  }

  private noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (value == null) {
      return null;
    }

    return value.toString().trim().length === 0
      ? { whitespace: true }
      : null;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.GetPaymentSettings();
  }

  GetPaymentSettings() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.paymentService.GetOnlinePaymentSettings().subscribe((res: any) => {
      if (!res.McsBitProcessCreditCardOnline) {
        this.PaymentSettingsForm.patchValue({
          McsBitProcessCreditCardOnline: res.McsBitProcessCreditCardOnline,
          EnableAutopay: res.EnableAutopay,
          EnableACH: res.EnableACH
        });
      } else {
        this.PaymentSettingsForm.patchValue({
          McsIntPaymentGateway: res.McsIntPaymentGateway,
          McsBitProcessCreditCardOnline: res.McsBitProcessCreditCardOnline,
          McsBitSecurityCodeMandatory: res.McsBitSecurityCodeMandatory,
          McsBitStreetZipMandatory: res.McsBitStreetZipMandatory,
          McsVchGatewayDetails: res.McsVchGatewayDetails,
          EnableAutopay: res.EnableAutopay,
          EnableACH: res.EnableACH,
          XWEBID: res.XWEBID,
          XWEBTERMINALID: res.XWEBTERMINALID,
          XWEBAUTHKEY: res.XWEBAUTHKEY,
          RCMURL: res.RCMURL,
          CardNotPresentURL: res.CardNotPresentURL,
          QueryPaymentStatusURL: res.QueryPaymentStatusURL,
          APIIntegrationURL: res.APIIntegrationURL,
          UserID: res.UserID,
          Password: res.Password,
          BatchCloseIntegrationURL: res.BatchCloseIntegrationURL,
          EcommerceXWebId: res.EcommerceXWebId,
          EcommerceXWebTerminalId: res.EcommerceXWebTerminalId,
          EcommerceXWebAuthKey: res.EcommerceXWebAuthKey,
          DISABLEDEBITSALE: res.DISABLEDEBITSALE,
          AccountId: res.AccountId,
          PublishableKey: res.PublishableKey,
          SecretKey: res.SecretKey,
          WebhookSecretKey: res.WebhookSecretKey,
          TransferWebhookSecretKey: res.TransferWebhookSecretKey,
          TerminalIpUrl: res.TerminalIpUrl,
          AccountOwner: res.AccountOwner,
          MandatoryAddressField: res.MandatoryAddressField
        });
      }
      if (res.McsBitProcessCreditCardOnline) {
        this.configureGatewayValidators();
      }
      this.toggleGatewayFields(
        this.PaymentSettingsForm.get('McsBitProcessCreditCardOnline')?.value
      );
      this.PaymentSettingsForm.markAsPristine();
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  private toggleGatewayFields(enable: boolean): void {

    const gatewayFields = [
      'McsIntPaymentGateway',
      'XWEBID',
      'XWEBTERMINALID',
      'XWEBAUTHKEY',
      'RCMURL',
      'CardNotPresentURL',
      'QueryPaymentStatusURL',
      'APIIntegrationURL',
      'AccountId',
      'PublishableKey',
      'SecretKey',
      'WebhookSecretKey',
      'TransferWebhookSecretKey',
      'TerminalIpUrl',
      'AccountOwner',
      'MandatoryAddressField'
    ];

    gatewayFields.forEach(field => {
      const control = this.PaymentSettingsForm.get(field);

      if (enable) {
        control?.enable({ emitEvent: false });
      }
      else {
        control?.disable({ emitEvent: false });
      }
    });

  }

  UpdatePaymentSettings(e: Event) {
    e.preventDefault();
    if (this.PaymentSettingsForm.get('McsIntPaymentGateway').value == 0 && this.PaymentSettingsForm.get('McsBitProcessCreditCardOnline').value == true) {
      this.toastr.error($localize`Select payment gateway`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    if (!this.validateForm()) {
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    if (this.PaymentSettingsForm.invalid) {
      this.toastr.error($localize`Check the form`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    Swal.fire({
      title: $localize`Are you sure ?`,
      text: $localize`Updating online payment settings`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,

    }).then((result) => {
      if (result.value) {

        this.loaderIcon = Promise.resolve(true);

        this.subscriptions.push(this.paymentService.UpdateOrSaveOnlinePaymentSettings(this.PaymentSettingsForm.getRawValue()).subscribe((res: any[]) => {
          this.response = res;
          if (this.response.Success) {
            this.toastr.success($localize`Payment setting updated`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            this.GetPaymentSettings();
          }
          else {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.error(this.response.Message, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
          }

          this.loaderIcon = Promise.resolve(false);
        }));

        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  cancel() {
    if (this.PaymentSettingsForm.dirty) {
      Swal.fire({
        title: $localize`Are you sure ?`,
        text: $localize`Changes wont be saved`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,

      }).then((result) => {
        if (result.value) {
          this.GetPaymentSettings();
        }
      });
    }
  }

  validateForm(): boolean {
    const missingFields: string[] = [];
    const gatewayId = this.PaymentSettingsForm.get('McsIntPaymentGateway')?.value;
    const fieldLabels =
      gatewayId == this.EPaymentGateway.OpenEdgeExpress
        ? this.openEdgeFieldLabels
        : gatewayId == this.EPaymentGateway.Stripe
          ? this.stripeFieldLabels
          : {};

    Object.keys(fieldLabels).forEach(field => {
      const control = this.PaymentSettingsForm.get(field);
      if (
        !control ||
        control.value === null ||
        control.value === undefined ||
        (typeof control.value === 'string' && control.value.trim() === '')
      ) {
        missingFields.push(fieldLabels[field]);
      }
    });

    if (missingFields.length > 0) {
      Swal.fire({
        title: $localize`Please check the Online Payment Setting form`,
        text: `${missingFields.join(', ')}\nRequired/Invalid`,
        icon: "warning",
        confirmButtonText: $localize`OK`
      });
      return false;
    }
    return true;
  }

  routeBack() {
    if (this.PaymentSettingsForm.dirty) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Unsaved changes will be lost. Are you sure you want to continue?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/dashboard']);
        }
      });
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  onTabChange(tab: string): void {
    if (tab === 'settings') {
      this.disSettings = true;
    } else {
      this.disSettings = false;
      this.loadTerminalDevices();
    }
  }

  private openTerminalModal(): void {

    const modal =
      bootstrap.Modal.getOrCreateInstance(
        this.terminalDeviceModal.nativeElement);

    modal.show();
  }

  private closeTerminalModal(): void {

    const modal =
      bootstrap.Modal.getInstance(
        this.terminalDeviceModal.nativeElement);

    modal?.hide();
  }

  loadTerminalDevices(): void {
    const gatewayId =
      this.PaymentSettingsForm.get('McsIntPaymentGateway')?.value;

    if (!gatewayId) {
      this.TerminalDevices = [];
      return;
    }

    this.subscriptions.push(
      this.paymentService.GetTerminalDevices(gatewayId)
        .subscribe({
          next: (res: any) => {
            this.TerminalDevices = res ?? [];
          },
          error: () => {
            this.TerminalDevices = [];
          }
        })
    );
  }

  addTerminalDevice(): void {
    this.isEditMode = false;
    this.TerminalDeviceForm.reset({
      Id: 0,
      Devices: '',
      TerminalReaderId: '',
      Primary: false,
      PaymentGatewayId:
        this.PaymentSettingsForm.get('McsIntPaymentGateway')?.value
    });
    this.TerminalDeviceForm.get('PaymentGatewayId')?.disable();
    this.openTerminalModal();
  }

  private validateDuplicateTerminal(): string | null {
    const device = this.TerminalDeviceForm.get('Devices')
      ?.value
      ?.trim()
      ?.toLowerCase();

    const terminalReaderId = this.TerminalDeviceForm.get('TerminalReaderId')
      ?.value
      ?.trim()
      ?.toLowerCase();

    const currentId = this.TerminalDeviceForm.get('Id')?.value;

    const duplicateDevice = this.TerminalDevices.find((x: any) =>
      x.Id !== currentId &&
      x.Devices?.trim().toLowerCase() === device
    );

    if (duplicateDevice) {
      return 'Device already exists.';
    }

    const duplicateReader = this.TerminalDevices.find((x: any) =>
      x.Id !== currentId &&
      x.TerminalReaderId?.trim().toLowerCase() === terminalReaderId
    );

    if (duplicateReader) {
      return 'Terminal Reader ID already exists.';
    }

    return null;
  }

  onRowSelecting(args: any): void {
    const target = args.target as HTMLElement;
    if (target.closest('.delete-column')) {
      args.cancel = true;
    }
  }

  editTerminalDevice(args: any): void {
    const device = args.data;
    this.TerminalDeviceForm.patchValue({
      Id: device.Id,
      Devices: device.Devices,
      TerminalReaderId: device.TerminalReaderId,
      Primary: device.Primary,
      PaymentGatewayId: device.PaymentGatewayId,
      PaymentGatewayName: device.PaymentGatewayName
    });
    this.TerminalDeviceForm.get('PaymentGatewayId')?.disable();
    const primaryControl = this.TerminalDeviceForm.get('Primary');
    if (device.Primary) {
      primaryControl?.disable();
    } else {
      primaryControl?.enable();
    }
    this.isEditMode = true;
    this.openTerminalModal();
  }

  saveTerminalDevice(): void {
    if (this.TerminalDeviceForm.invalid) {
      this.TerminalDeviceForm.markAllAsTouched();
      this.TerminalDeviceForm.updateValueAndValidity();

      this.toastr.warning(
        $localize`Please fill in all required fields.`,
        $localize`Validation`,
        this.sharedHTMLSettings.ToasterConfig
      );

      return;
    }

    const duplicateMessage = this.validateDuplicateTerminal();

    if (duplicateMessage) {
      this.toastr.error(duplicateMessage, $localize`Duplicate Record`, this.sharedHTMLSettings.ToasterConfig);
      return;
    }

    const payload = {
      ...this.TerminalDeviceForm.getRawValue(),
      Devices: this.TerminalDeviceForm.get('Devices')?.value?.trim(),
      TerminalReaderId: this.TerminalDeviceForm.get('TerminalReaderId')?.value?.trim(),
      PaymentGatewayId:
        this.PaymentSettingsForm.get('McsIntPaymentGateway')?.value
    };

    this.subscriptions.push(this.paymentService
      .SaveTerminalDevice(payload)
      .subscribe({
        next: res => {
          if (!res.Success) {
            this.toastr.error(res.Message, $localize`Duplicate Record`, this.sharedHTMLSettings.ToasterConfig);
            return;
          }

          this.toastr.success(res.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          this.loadTerminalDevices();
          this.GetPaymentSettings();
          this.closeTerminalModal();
        }
      }));
  }


  deleteTerminalDevice(device: any): void {
    if (device.Primary) {
      this.toastr.warning(
        $localize`Primary terminal device cannot be deleted.`,
        $localize`Validation`,
        this.sharedHTMLSettings.ToasterConfig
      );
      return;
    }

    Swal.fire({
      title: 'Delete Device?',
      text: 'Are you sure you want to delete this terminal device?',
      icon: 'warning',
      showCancelButton: true
    }).then(result => {
      if (!result.isConfirmed) {
        return;
      }

      this.subscriptions.push(
        this.paymentService.DeleteTerminalDevice(device.Id)
          .subscribe({
            next: res => {
              if (!res.Success) {
                this.toastr.error(res.Message, $localize`Validation`, this.sharedHTMLSettings.ToasterConfig);
                return;
              }
              this.toastr.success(res.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
              this.loadTerminalDevices();
            }
          }));
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

}
